import { News, NewsCenter } from "../../types";
import BaseController from "./BaseController";

class NewsCenterController extends BaseController {
  static getNews(params: object = {}): Promise<{
    news: News[]
    current_page: number
    total_pages: number
  }> {
    return this.post('messenger/news_center/news', params);
  }

  static getNewsItem(id: string): Promise<{
    news_center: NewsCenter
    news: News
  }> {
    return this.post(`messenger/news_center/news/${id}`);
  }
}

export default NewsCenterController